// src/components/modalForm/ModalQuantityControl.js
import React from 'react';
import { FiMinus, FiPlus } from 'react-icons/fi';

const ModalQuantityControl = ({ name, value, onDecrease, onIncrease, decreaseDisabled = false, increaseDisabled = false, decreaseProps = {}, increaseProps = {}, className = '' }) => (
  <div className={`modal-quantity-control ${className}`.trim()} onClick={(event) => event.stopPropagation()} onDoubleClick={(event) => event.stopPropagation()}>
    <button type="button" {...decreaseProps} disabled={decreaseDisabled} aria-label={`Diminuir ${name}`} onClick={onDecrease}><FiMinus aria-hidden="true" /></button>
    <output aria-label={`Quantidade de ${name}`}>{value}</output>
    <button type="button" {...increaseProps} disabled={increaseDisabled} aria-label={`Adicionar ${name}`} onClick={onIncrease}><FiPlus aria-hidden="true" /></button>
  </div>
);

export default ModalQuantityControl;
